import { Modal } from 'antd';
import { PureComponent, ReactNode } from 'react';
import { OneMgSvg } from './OrderMedicineUtils';
import { openCrispChat } from '../../../../pages/utils';

interface Props {
    isVisible?: boolean;
    closeMe: () => void;
}

export class HXNGInfoModal extends PureComponent<Props> {
    onLearnMore = (): void => {
        openCrispChat('ON_LEARN_MORE_HXNG_INFO_MODAL', {}, 'I need help with health exchange');
    };

    render(): ReactNode {
        const { isVisible, closeMe } = this.props;
        const { onLearnMore } = this;

        return (
            <Modal
                onCancel={closeMe}
                width={780}
                closable={false}
                visible={isVisible}
                destroyOnClose
                footer={null}
                bodyStyle={{
                    padding: '0px',
                    borderRadius: '12px !important',
                    height: '580px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
                className="overflow-hidden rounded-12"
                style={{ height: '580px', color: '#1A1A1A', top: '7.5vh' }}
            >
                <div className="flex flex-col h-full w-full">
                    <div className="flex-1 overflow-auto space-y-18 pt-24 px-18 pb-16 bg-darwin-neutrals-50">
                        <div className="flex flex-col items-center font-700 space-y-5">
                            <p className="text-16">You’ve unlocked benefits 🎉 for your patients</p>
                            <p className="text-33">Healthcare to Patients’ home</p>
                        </div>
                        <div className="grid grid-cols-2 gap-16">
                            <div className="flex items-start space-x-8 p-16 border border-darwin-neutral_new-200 bg-white rounded-16">
                                <div>
                                    <img
                                        src="/images/hxng-pharma.png"
                                        alt="hxng pharma"
                                        className="w-52 h-52"
                                        loading="lazy"
                                    />
                                </div>
                                <div>
                                    <p className="text-20 font-700" style={{ color: '#FF6208' }}>
                                        Medicines
                                    </p>
                                    <div className="space-y-8">
                                        <div>
                                            <p className="font-700">Home delivery</p>
                                            <p className="text-11 text-darwin-neutrals-600">
                                                for your prescribed medicines to patients’ doorstep.
                                            </p>
                                        </div>
                                        <div>
                                            <p className="font-700">Exclusive patient offers</p>
                                            <p className="text-11 text-darwin-neutrals-600">
                                                up to 16% off on medicines.
                                            </p>
                                        </div>
                                        <div>
                                            <p className="font-700">100% fulfilment</p>
                                            <p className="text-11 text-darwin-neutrals-600">
                                                Ensure patients get all prescribed medicines,
                                                delivered via
                                            </p>
                                            <p className="pt-5">
                                                <OneMgSvg width="90" height="28" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-start space-x-8 p-16 border border-darwin-neutral_new-200 bg-white rounded-16">
                                <div>
                                    <img
                                        src="/images/hxng-lab.png"
                                        alt="hxng lab"
                                        className="w-52 h-52"
                                        loading="lazy"
                                    />
                                </div>
                                <div>
                                    <p className="text-20 font-700" style={{ color: '#FF6208' }}>
                                        Diagnostic tests
                                    </p>
                                    <div className="space-y-8">
                                        <div>
                                            <p className="font-700">Home sample collection</p>
                                            <p className="text-11 text-darwin-neutrals-600">
                                                for lab tests and health packages to patients.
                                            </p>
                                        </div>
                                        <div>
                                            <p className="font-700">Flat 40% off for patients</p>
                                            <p className="text-11 text-darwin-neutrals-600">
                                                on health packages and 30% off on lab tests.
                                            </p>
                                        </div>
                                        <div>
                                            <p className="font-700">
                                                Instant access to patient reports
                                            </p>
                                            <p className="text-11 text-darwin-neutrals-600">
                                                You will see digital report on tool and it’s sent to
                                                your patients on WhatsApp.
                                            </p>
                                            <p className="pt-5">
                                                <img
                                                    src="/images/labs_vendors.gif"
                                                    alt={'v_001'}
                                                    className="h-36 min-w-64"
                                                    loading="lazy"
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="font-700 text-darwin-neutral_new-800 flex justify-center flex-wrap space-x-16">
                            <div className="flex items-center space-x-8">
                                <p>
                                    <svg
                                        className="w-18 h-16"
                                        viewBox="0 0 18 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM12.5312 6.53125H12.5C12.8125 6.25 12.8125 5.78125 12.5 5.46875C12.2188 5.1875 11.75 5.1875 11.4688 5.46875L8 8.96875L6.53125 7.5C6.21875 7.1875 5.75 7.1875 5.46875 7.5C5.15625 7.78125 5.15625 8.25 5.46875 8.53125L7.46875 10.5312C7.75 10.8438 8.21875 10.8438 8.53125 10.5312L12.5312 6.53125Z"
                                            fill="#FF6208"
                                        />
                                    </svg>
                                </p>
                                <p>End to End Visibility of Order Delivery</p>
                            </div>
                            <div className="flex items-center space-x-8">
                                <p>
                                    <svg
                                        className="w-18 h-16"
                                        viewBox="0 0 18 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM12.5312 6.53125H12.5C12.8125 6.25 12.8125 5.78125 12.5 5.46875C12.2188 5.1875 11.75 5.1875 11.4688 5.46875L8 8.96875L6.53125 7.5C6.21875 7.1875 5.75 7.1875 5.46875 7.5C5.15625 7.78125 5.15625 8.25 5.46875 8.53125L7.46875 10.5312C7.75 10.8438 8.21875 10.8438 8.53125 10.5312L12.5312 6.53125Z"
                                            fill="#FF6208"
                                        />
                                    </svg>
                                </p>
                                <p>Facilitation Fees for Clinic</p>
                            </div>
                            <div className="flex items-center space-x-8">
                                <p>
                                    <svg
                                        className="w-18 h-16"
                                        viewBox="0 0 18 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM12.5312 6.53125H12.5C12.8125 6.25 12.8125 5.78125 12.5 5.46875C12.2188 5.1875 11.75 5.1875 11.4688 5.46875L8 8.96875L6.53125 7.5C6.21875 7.1875 5.75 7.1875 5.46875 7.5C5.15625 7.78125 5.15625 8.25 5.46875 8.53125L7.46875 10.5312C7.75 10.8438 8.21875 10.8438 8.53125 10.5312L12.5312 6.53125Z"
                                            fill="#FF6208"
                                        />
                                    </svg>
                                </p>
                                <p>Incentives for Staff</p>
                            </div>
                        </div>
                        <div className="flex items-start text-white bg-darwin-green-primary p-16 rounded-16">
                            <div className="flex-1 space-y-4">
                                <p className="text-20">
                                    Unlock potential earning of{' '}
                                    <span className="font-700">₹1.5L per month!</span>
                                </p>
                                <p className="text-13">
                                    <span className="font-700">35k+ happy patients</span> served in
                                    India.
                                </p>
                            </div>
                            <div>
                                <button
                                    className="text-13 font-700 text-darwin-green-primary bg-white px-12 py-10 rounded-8"
                                    onClick={onLearnMore}
                                >
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white flex justify-center p-10">
                        <button
                            className="px-12 py-10 text-white bg-darwin-accent-bright-blue-800 rounded-8 text-13 font-700"
                            onClick={closeMe}
                        >
                            Okay, got it
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}
